import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SmHeader from "../../components/ForPages/SmHeader";
import HomeHeader from "../../components/ForPages/HomeHeader";
import Footer from "../../components/ForPages/Footer";
import "../Home/Home.css";
import "../Home/Responsive.css";
import classes from "./SkiContents.module.css";
import PaymentPopup from "../../components/PaymentPopup";

export default function SkiContents() {
  document.body.style.backgroundColor = "#E5E4EF";
  const token = "skiContents",
    [contents, setContents] = useState([]),
    [PaymentPopupDisplay, setPaymentPopupDisplay] = useState("none");
  useEffect(() => {
    let newContents = [
      {
        title: "Branding Your Business After Pandemic",
        subTitle: "Branding Your Business After Pandemic",
        description:
          "Branding Your Business After Pandemic. Branding Your Business After Pandemic. Branding Your Business After Pandemic",
        contentFor: "Twitter Post",
        author: "Leilla Nancy",
      },
      {
        title: "Branding Your Business After Pandemic",
        subTitle: "Branding Your Business After Pandemic",
        description:
          "Branding Your Business After Pandemic. Branding Your Business After Pandemic. Branding Your Business After Pandemic",
        contentFor: "Twitter Post",
        author: "Leilla Nancy",
      },
      {
        title: "Branding Your Business After Pandemic",
        subTitle: "Branding Your Business After Pandemic",
        description:
          "Branding Your Business After Pandemic. Branding Your Business After Pandemic. Branding Your Business After Pandemic",
        contentFor: "Twitter Post",
        author: "Leilla Nancy",
      },
      {
        title: "Branding Your Business After Pandemic",
        subTitle: "Branding Your Business After Pandemic",
        description:
          "Branding Your Business After Pandemic. Branding Your Business After Pandemic. Branding Your Business After Pandemic",
        contentFor: "Twitter Post",
        author: "Leilla Nancy",
      },
      {
        title: "Branding Your Business After Pandemic",
        subTitle: "Branding Your Business After Pandemic",
        description:
          "Branding Your Business After Pandemic. Branding Your Business After Pandemic. Branding Your Business After Pandemic",
        contentFor: "Twitter Post",
        author: "Leilla Nancy",
      },
    ];
    setContents([]);
    setContents(newContents);
  }, [token]);
  return (
    <div className="Home">
      <SmHeader />
      <HomeHeader tab="contents" include="contents" showPaymentPopup={setPaymentPopupDisplay} />
      <div className="Middle-welcome">
        <h2>Welcome to Ski Studio</h2>
        <p>Access 1 Free Social Media Post content per month</p>
      </div>
      <div className={classes.SkiContents}>
        {contents.length > 0
          ? contents.map((content, index) => (
            <div className={classes.OneContent} key={index}>
              <p>
                <span>Title: </span>
                {content.title}
              </p>
              <p>
                <span>Sub-Title: </span>
                {content.subTitle}
              </p>
              <p>
                <span>Description: </span>
                {content.description}
              </p>
              <div>
                <Link to="/ski-contents">READ MORE</Link>
              </div>
              <div>
                <div>
                  <p>
                    <span>Content for: </span>
                    {content.contentFor}
                  </p>
                  <p>
                    <span>Author: </span>
                    {content.contentFor}
                  </p>
                </div>
                <button>Apply & Create Design</button>
              </div>
            </div>
          ))
          : "No contents yet. Check back later."}
      </div>
      <Footer />
      <PaymentPopup
        display={PaymentPopupDisplay}
        hidePopupDisplay={setPaymentPopupDisplay}
      />
    </div>
  );
}
